<db-dialog-wrapper [dialog]="this" [width]="'1040px'" [height]="'100%'">
  <div class="db-extensions">
    <div class="db-extensions__logo" *ngIf="product">
      <div><img src="{{product?.logo}}" /></div>
      <h4>{{'text_extensions' | dbText: { pluginTitle: product?.title} }}</h4>

      <div class="db-extensions__rating clearfix">
        <div>
          <span>{{product?.rating}}</span>
          <db-rating-stars [rating]="product?.rating"></db-rating-stars>
        </div>
        <div>
          <span>{{product?.downloads | number}}+</span>
          <p>{{'text_activeInstallsText' | dbText}}</p>
        </div>
      </div>

    </div>
    <div class="main-content-wrap">
      <div class="db-extensions__general" dbCustomScrollbar>
        <div>
          <div class="db-extensions__list">
            <db-extension-item [@productItemAnimation]="!updatingProductsList" [scope]="scope" [website]="website" (toggled)="onItemToggled()" [product]="addOn" [parentProduct]="product" [isManagable]="isManagable" [userSubscriptions]="userSubscriptions" [currentSubscription]="currentSubscription" *ngFor="let addOn of addOns; trackBy: productTrackBy;"></db-extension-item>
          </div>
        </div>
      </div>
      <db-loading-screen *ngIf="loading || booleanLoading" [pageBlocker]="true"></db-loading-screen>
    </div>

    <div class="db-extensions__filters db-filters-bar">

      <label class="db-extensions__select-all-toggle" *ngIf="isManagable">
        <span class="db-fc-checkbox" *ngIf="currentSubscription.type === 'bundle' || currentSubscription.type === 'platform'">
          <input type="checkbox" [formControl]="selectAll" (change)="toggleAllItemsSelected($event.currentTarget.checked)">
          <span><i class="db-icon db-icon-check"></i></span>
        </span>
        <span *ngIf="currentSubscription.type === 'bundle' || currentSubscription.type === 'platform'">{{'text_selectAll' | dbText}}</span>
      </label>

      <span *ngIf="isManagable">
        <span *ngIf="!!selectedAddOns.length && !!product.hasPaidVersion && !product.availableForHosting" class="db-extensions__selected">{{'text_selectedAddOnsCount' | dbText : {selectedAddOnsCount: selectedAddOns.length} }}</span>
        <span *ngIf="!!selectedAddOns.length && !!product.hasPaidVersion && !!product.availableForHosting && website.domain_hash" class="db-extensions__selected">{{'text_selectedAddOnsCount' | dbText : {selectedAddOnsCount: selectedAddOns.length} }}</span>
        <a class="db-button db-button_info" [ngClass]="{'db-button_disabled': !selectedAddOns.length || !product.hasPaidVersion}" (click)="applyBulkAction(ActivityAction.INSTALL)"><span>{{'text_install' | dbText}}</span></a>
      </span>
    </div>

  </div>
</db-dialog-wrapper>
